var map = {
	"./10_gk.png": 3110,
	"./11_gk.png": 1921,
	"./12_gk.png": 5996,
	"./13_gk.png": 2879,
	"./14_gk.png": 6162,
	"./15_gk.png": 141,
	"./16_gk.png": 5784,
	"./17_gk.png": 5131,
	"./18_gk.png": 1438,
	"./19_gk.png": 4681,
	"./1_gk.png": 1902,
	"./20_gk.png": 2089,
	"./2_gk.png": 3975,
	"./3_gk.png": 4324,
	"./4_gk.png": 6933,
	"./5_gk.png": 3962,
	"./6_gk.png": 4035,
	"./7_gk.png": 8192,
	"./8_gk.png": 7057,
	"./9_gk.png": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3734;